import { reactive } from "vue";

// Un solo cuadro de confirmación para toda la app (se monta en App.vue).
// Uso: if (!(await askConfirm({ title, message, confirmText, tone }))) return;
const state = reactive({
  open: false,
  title: "",
  message: "",
  confirmText: "Confirmar",
  tone: "danger",
  icon: "fas fa-exclamation-triangle",
});
let resolver = null;

const settle = (answer) => {
  state.open = false;
  if (resolver) resolver(answer);
  resolver = null;
};

const askConfirm = (options) => {
  if (resolver) resolver(false); // una pregunta a la vez
  Object.assign(state, {
    confirmText: "Confirmar",
    tone: "danger",
    icon: "fas fa-exclamation-triangle",
    message: "",
    ...options,
    open: true,
  });
  return new Promise((resolve) => {
    resolver = resolve;
  });
};

const useConfirm = () => ({
  confirmState: state,
  askConfirm,
  confirm: () => settle(true),
  cancel: () => settle(false),
});

export { askConfirm };
export default useConfirm;
